import { useGetMentorsByUniversityRegion } from '@actions';
import Modal from '@components/V4/Modal/Modal';
import { PaginationProps } from '@components/V4/Pagination';
import DetailsModal from '@modules/Admin/components/DetailsModal/DetailsModal';
import { UserRole } from '@shared/enums';
import { useState } from 'react';
import ProfilesModalTable from '../ProfilesModalTable';

interface MentorsByUniversityRegionProps {
  region: string;
  title: string;
}

const MentorsByUniversityRegion = (props: MentorsByUniversityRegionProps) => {
  const { region, title } = props;
  const [limit, setLimit] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const { data: mentorsByUniversityRegion, isLoading: areUsersLoading } =
    useGetMentorsByUniversityRegion({
      limit,
      page,
      sortBy,
      sortOrder,
      region,
    });

  const currentPageChangeHandler = (page: number) => {
    setPage(page);
  };

  const pageSizeChangeHandler = (size: number) => {
    setLimit(size);
  };

  const pagination: PaginationProps = {
    pageSize: limit || 10,
    total: mentorsByUniversityRegion ? mentorsByUniversityRegion.total : 0,
    currentPage: page || 1,
    onCurrentPageChange: currentPageChangeHandler,
    onPageSizeChange: pageSizeChangeHandler,
  };

  const usersList = mentorsByUniversityRegion?.users;

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [userId, setUserId] = useState<string>();

  const userModalOpenHandler = (userId: string) => {
    setUserId(userId);
    setShowDetailsModal(true);
  };

  const closeSessionModalHandler = () => {
    setShowDetailsModal(false);
  };

  return (
    <>
      <Modal.Header title={`Mentors from ${title}:`} />
      <Modal.Body>
        <ProfilesModalTable
          usersList={usersList || []}
          areUsersLoading={areUsersLoading}
          pagination={pagination}
          userModalOpenHandler={userModalOpenHandler}
          role={UserRole.Mentor}
        />
      </Modal.Body>
      {showDetailsModal && (
        <DetailsModal
          page={'mentor'}
          isOpen={true}
          onClose={closeSessionModalHandler}
          mentorId={userId}
        />
      )}
    </>
  );
};

export default MentorsByUniversityRegion;
